const BASE_ACTION_TYPE = 'LANDLORD::PROPERTIES::MULTISELECT';

export const FETCH_PROPERTIES = `${BASE_ACTION_TYPE}::FETCH_PROPERTIES`;
export const FETCH_PROPERTY_FILTERS = `${BASE_ACTION_TYPE}::FETCH_PROPERTY_FILTERS`;
export const FETCH_PROPERTIES_FOR_REVIEW = `${BASE_ACTION_TYPE}::FETCH_PROPERTIES_FOR_REVIEW`;
